import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const lang = document.documentElement.lang.split('-')[0];

    this.element.classList.add('loading');

    const postID = this.element.dataset.pid;
    const blockID = this.element.dataset.bid;

    fetch(`/wp-json/api/async-render-block?pid=${postID}&bid=${blockID}&lang=${lang}`)
      .then(response => response.json())
      .then(response => {
        this.element.classList.remove('loading');

        if (response.success) {
          this.element.innerHTML = response.content;
        }
      })
      .catch(error => {
        console.error(error);
        this.element.classList.remove('loading');
      });
  }
}
